import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

export const TOGGLE_COLORS = {
  GREEN: 'green',
  GRAY: 'gray',
} as const;

@Component({
  selector: 'app-slide-toggle',
  templateUrl: './slide-toggle.component.html',
  styleUrls: ['./slide-toggle.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

/**
 * A slide toggle that overrides Angular Material <mat-slide-toggle>.
 * Is an on/off control that can be toggled via clicking.
 */
export class SlideToggleComponent {
  @Input() checked = false;
  @Input() disabled = false;
  @Input() isBigToggle = false;
  @Output() checkedChange = new EventEmitter<boolean>();
  @Input() activeColor? = TOGGLE_COLORS.GREEN;
  @Input() inactiveColor? = TOGGLE_COLORS.GRAY;

  /**
   * On Toggle Change
   * @param {MatSlideToggleChange} event
   */
  onToggleChange(event: MatSlideToggleChange) {
    if (!this.disabled) {
      this.checkedChange.emit(event.checked);
    }
  }

  /**
   * Returns the active color if toggle is checked or the inactive if is not.
   */
  get currentColorClass(): string {
    return this.checked ? this.activeColor! : this.inactiveColor!;
  }
}
